<template>
    <div>
        <div class="hound">
            <img
            v-if="!color"
            class="returns"
            @click="returnBtn"
            src="../../assets/h5/back.png"
            alt=""
            />
            <img
            v-else
            class="returns"
            @click="returnBtn"
            src="../../assets/h5/back2.png"
            alt=""
            />
            <p :style="{
                color: color
            }">{{ text }}</p>
            <span class="history-btn" v-if="historyBtn" @click="toHistoryPage"></span>
        </div>
    </div>
</template>
<script>
    export default {
        name:"top-header",
        props:["text","color",'historyBtn','guildId','guildUid','toUrl'],
        data() {
            return {
                isLogin: false,
                userInfo: {},
            }
        },
        mounted() {
        },
        methods: {
            returnBtn() {
                // historybtn为真  在点击返回说明需要关闭webview
                if(this.historyBtn){
                    return this.$completes.complete("getPreviousPage");
                }
                if (window.history.length <= 1) {
                    // 没有上一页，关闭webview
                    this.$completes.complete("getPreviousPage");
                } else {
                    this.$router.go(-1);
                }
            },
            // 跳转到历史记录
            toHistoryPage(){
                console.log(this.toUrl)
                this.$router.push({ 
                    path: "/withdrawal-history",
                    query: { 
                        guildId:this.guildId,
                        guildUid:this.guildUid,
                        toUrl: this.toUrl
                    }
                 });
            }
        }
    }
</script>
<style>
    html[lang="ar"] .returns {
        /* -webkit-transform: rotateY(180deg); */
        right: 28px;
        transform: rotateY(180deg);
    }
    html[lang="ar"] .history-btn {
        left: 28px;
        right: auto;
        transform: rotateY(180deg);
    }
    html[lang="ar"] .hound p{
        padding-left: 0;
        padding-right: 40px;
    }
    .hound {
        width: 100%;
        height: 130px;
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        box-sizing: border-box;
        position:relative;
        padding-top: calc(30px + env(safe-area-inset-top));
        padding-top: calc(30px + constant(safe-area-inset-top)); 
    }
    .hound p {
        flex: 1;
        font-size: 30px;
        font-weight: 600;
        color: #fff;
        text-align: center;
        font-family: 'Mada';
        padding-left: 40px;
    }
    .returns {
        /* width: 0.8rem;
        height: 0.8rem; */
        width: 28px;
        height: 28px;
        position: absolute;
    }
    .history-btn{
        /* position: absolute; */
        /* top: 47%; */
        right: 28px;
        width: 40px;
        height: 40px;
        top: calc(47% + env(safe-area-inset-top));
        background: url("../../assets/withdrawal/history-btn.png") no-repeat;
        background-size: 100% 100%;
    }
</style>